import { render } from "./GiftCardFees.vue?vue&type=template&id=837c42e0"
import script from "./GiftCardFees.vue?vue&type=script&lang=js"
export * from "./GiftCardFees.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import PageTitle from "@/components/PageTitle.vue";
import Currency from "@/components/Currency.vue";
import GiftCardFeeModal from "@/components/GiftCardFeeModal.vue";
script.components = Object.assign({}, { Breadcrumbs, PageTitle, Currency, GiftCardFeeModal }, script.components);